var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{staticStyle:{"padding":"0"},attrs:{"image":"/images/empty-image-default.png","description":_vm.message || _vm.$t('暂无数据')}})}
var staticRenderFns = []

export { render, staticRenderFns }